import { useContext, useState } from "react";
import axios from "axios";
import { AuthContext } from "../App";

export default function Profile() {
    const { user, login } = useContext(AuthContext) || {};
    const [form, setForm] = useState({
        fullName: user?.fullName || "",
        email: user?.email || "",
        phoneNumber: user?.phoneNumber || "",
        gender: user?.gender || "",
    });
    const [editing, setEditing] = useState(false);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState("");

    const handleChange = e => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSave = async () => {
        setSaving(true);
        setMessage("");
        try {
            await axios.put(`/api/v1/admin/users/${user._id}`, form);
            setMessage("Profile updated!");
            setEditing(false);
            // Optionally refresh user info in context
            login && login(form.email, null); // null password, just to refresh
        } catch (e) {
            setMessage("Failed to update profile");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="max-w-xl mx-auto bg-white rounded-xl shadow p-8 mt-8">
            <h2 className="text-2xl font-bold mb-6 text-Besty-600">Admin Profile</h2>
            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-medium mb-1">Full Name</label>
                    <input
                        className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-Besty-200"
                        name="fullName"
                        value={form.fullName}
                        onChange={handleChange}
                        disabled={!editing}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium mb-1">Email</label>
                    <input
                        className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-Besty-200"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        disabled={!editing}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium mb-1">Phone Number</label>
                    <input
                        className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-Besty-200"
                        name="phoneNumber"
                        value={form.phoneNumber}
                        onChange={handleChange}
                        disabled={!editing}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium mb-1">Gender</label>
                    <input
                        className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-Besty-200"
                        name="gender"
                        value={form.gender}
                        onChange={handleChange}
                        disabled={!editing}
                    />
                </div>
            </div>
            <div className="flex gap-2 mt-6">
                {editing ? (
                    <>
                        <button
                            className="px-4 py-2 bg-Besty-500 text-white rounded hover:bg-Besty-600"
                            onClick={handleSave}
                            disabled={saving}
                        >
                            {saving ? "Saving..." : "Save"}
                        </button>
                        <button
                            className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                            onClick={() => setEditing(false)}
                            disabled={saving}
                        >
                            Cancel
                        </button>
                    </>
                ) : (
                    <button
                        className="px-4 py-2 bg-Besty-500 text-white rounded hover:bg-Besty-600"
                        onClick={() => setEditing(true)}
                    >
                        Edit Profile
                    </button>
                )}
            </div>
            {message && <div className="mt-4 text-Besty-600">{message}</div>}
        </div>
    );
} 